// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3Qfyw","colCheckbox":"styles_colCheckbox__3pYvK"};